/** * * Asynchronously loads the component for
PlatformDrivers
* */ import { lazyLoad } from "utils/loadable";
export const PlatformDrivers = lazyLoad(
  () => import("./index"),
  (module) => module.PlatformDrivers
);
